import React from 'react'
import BlogPost from '../component/BlogPost'
import Newsletter from '../component/Newsletter'

const BlogDetails = () => {
  return (
    <main className="main__content_wrapper">
    <section className="breadcrumb__section breadcrumb__bg">
      <div className="container">
        <div className="row row-cols-1">
          <div className="col">
            <div className="breadcrumb__content">
              <h1 className="breadcrumb__content--title text-white mb-10">
                Blog Details
              </h1>
              <ul className="breadcrumb__content--menu d-flex">
                <li className="breadcrumb__content--menu__items">
                  <a className="text-white" href="/">Home</a>
                </li>
                <li className="breadcrumb__content--menu__items">
                  <span className="text-white">Blog Details</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="blog__details--section section--padding">
      <div className="container">
      
        <BlogPost />
        {/* <BlogPostFooter /> */}
      </div>
    </section>

    <Newsletter />
  </main>
  )
}

export default BlogDetails